// French category labels.
export const HELP_CATEGORIES = [
  { id: 'getting-started', label: 'Premiers pas', icon: '🚀' },
  { id: 'data', label: 'Préparation et téléversement des données', icon: '📁' },
  { id: 'analysis', label: 'Lancer une analyse', icon: '▶️' },
  { id: 'results', label: 'Comprendre les résultats', icon: '📊' },
  { id: 'troubleshooting', label: 'Dépannage', icon: '🛠️' },
]
